import axios from "axios";
import _get from "lodash/get";
import { BASE_URL, SET_AND_ACTIVATE_LAYOUT, UPLOAD_BULK_CSV } from "./Utils/constant";
import { store } from "../src/Utils/Redux/store";
import { getAbortSignal } from "./Utils/AbortController";
import { LogEvents } from "./Utils/eventLogger";


const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

instance.interceptors.request.use(
  function (config) {
    const publicUrls = [
      "api/v1/user/login",
      "api/v1/issuer/create-issuer",
      "api/v1/verifier/register-verifier",
      "api/v1/user/send-otp",
      'api/v1/user/verify-otp',
      'api/v1/user/verify-token',
      'api/v1/issuer/generate-key-pair/',
      'api/v1/issuer/update-phone',
      'api/v1/user/send-mfa',
      'api/v1/user/verify-mfa',
      '/api/v1/user/forgot-password/',
      '/api/v1/user/set-password'
    ];
    config.signal = getAbortSignal()

    const requiresAuthorization = !publicUrls.some(url => config.url.includes(url));
    const state = store.getState();
    const { User } = state;
    if (config.method == "post") {
      delete config.headers.common;
      if (config.url.includes("api/v1/issuer/update-issuer") || config.url === "/api/v1/verifier/update-verifier" || config.url === 'api/v1/issuer/add-document-template' || config.url === '/api/v1/issuer/add-document-layout' || config.url === SET_AND_ACTIVATE_LAYOUT || config.url === 'api/v1/issuer/upload-csv' || config.url === 'api/v1/issuer/create-issuer' || config.url === 'api/v1/verifier/register-verifier' || config.url === '/api/v1/verifier/upload-bulk-verification-request-by-doc-field' || config.url==="/api/v1/verifier/add-request-to-cart" || config.url==='/api/v1/verifier/upload-loa' || config.url==='/api/v1/verifier/create-appeal/' || config.url==="/api/v1/wa/create-wa-appeal" || config.url==="/api/v1/wa/create-wa-request" ||config.url==="/api/v1/verifier/get-s3-signed-url" || config.url==="/api/v1/issuer/convert-document-background") {
        config.headers["Content-Type"] = "multipart/form-data";
      } else {
        config.headers["Content-Type"] = "application/json";
      }
    }
    if (requiresAuthorization) {
      config.headers["Authorization"] = "Bearer " + User.access_token;
    }
    config.retry = 1;
    config.retryDelay = 1000;

    //    LogEvents(User.user_name, "API", {url: config.url, method: config.method})
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor with retry logic
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const config = error.config;
    if (error.name === 'CanceledError') {
      if (error.message == 'CanceledError') {
        cogoToast.info('Session Expired! Logging you out');
      }
      // error.message = "Session Expired! Logging you out"
      // console.log('Request was aborted, no retry will be attempted.');
      // return Promise.reject({ ...error, response: { data: { message: 'Error Occured, Logging out' } } })
      return Promise.reject(error);
    }
    if (
      !config ||
      !config.retry ||
      config.retryCount >= config.retry ||
      (error.response && error.response.status !== 500)
    ) {
      let message = "Error while fetching data from server";
      if (error.response && error.response.data && error.response.data.detail) {
        message = error.response.data.detail;
      }
      return Promise.reject(error);
    }

    // Increase the retry count
    config.retryCount = config.retryCount || 0;
    config.retryCount += 1;

    // Calculate retry delay
    const backOffDelay = config.retryDelay * Math.pow(2, config.retry);

    // Return a promise that resolves after a delay and then retries the request
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(instance(config));
      }, backOffDelay);
    });
  }
);

export default instance;
